module.exports = __webpack_public_path__ + "img/download.bc141a54.svg";